import {ApiResponse, apiClient} from "@/shared/api";
import { Contact } from "../model";

export const updateContact = (userId: string, firstName: string, lastName: string): Promise<ApiResponse<Contact>> => {
  return apiClient(`/api/contacts/${userId}`, "put", {firstName, lastName});
};

export const getContacts = (page = 1): Promise<ApiResponse<Contact[]>> => {
  return apiClient(
    `/api/contacts/?page=${page}&limit=50`,
    "get"
  );
};

export const searchContacts = (
  page = 1,
  query?: string
): Promise<ApiResponse<Contact[]>> => {
  return apiClient(
    `/api/search/contacts/?page=${page}&limit=50${query ? `&query=${query}` : ""}`,
    "get"
  );
};
